import { render, staticRenderFns } from "./ItemUnit.vue?vue&type=template&id=6522ed23&"
import script from "./ItemUnit.vue?vue&type=script&lang=js&"
export * from "./ItemUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports